<script>
import Radio from "@/pages/components/form/horizontal/radio.vue";
import FormGroup from "@/pages/components/form/horizontal/form-group.vue";
import formInput from "@wielink-application/shared/js/mixins/formInput";
import MultipleRadios from "@/pages/components/form/input-only/multiple-radios.vue";

export default {
  mixins: [formInput],
  components: {MultipleRadios, Radio, FormGroup},
  props: {
    label: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    layout: {
      type: String,
      default: 'horizontal'
    }
  }
}
</script>
<template>
  <FormGroup>
    <template v-if="label" #label>
      {{ label }}
    </template>
    <MultipleRadios
        v-bind="$attrs"
        :form="form"
        :model-value="modelValue"
        :name="name"
        :options="options"
        @update:modelValue="changeModelValueTo"
        :layout="layout"
    />
  </FormGroup>
</template>
